<template>
  <div class="wrapper">
    <div class="brief">
      <div @click="detailsbtn">
        <img :src="departmentIcon" alt="科室图片" />
        <div>
          <p>{{department.deptName}}</p>
          <p>茂名市慢性疾病防治中心</p>
        </div>
      </div>
    </div>
    <ul class="doctorSel" v-if="list.length != 0?true:false">
      <li v-for="item in list" :key="item.drcode">
        <img :src="item.img" />
        <div>
          <p class="doctor_name">
            <span>{{item.drname}}</span>
            <span>{{item.professional}}</span>
          </p>
          <p style="margin: 5px 0px">
            <span>茂名市慢性疾病防治中心</span>
            <!-- <span style="margin-left: 10px">{{department.deptName}}</span> -->
          </p>
          <foldText
            :showContent="item.introduce"
          ></foldText>
        </div>
        <!-- <span class="yybtn_cl" @click="makebtn">
          预约挂号
        </span> -->
      </li>
    </ul>
    <div class="depnone" v-if="list.length == 0?true:false">
      暂无值班医生
    </div>
  </div>
</template>

<script>
import { GetRequest } from "@/tool/parameter.js"
import { selectBDoctorinfo } from "@/request/api.js";
import foldText from "@/components/foldText/foldText";
export default {
  components: {
    foldText
  },
  data() {
    return {
      department: {},
      list: []
    };
  },
  async created() {
    this.department = JSON.parse(sessionStorage.getItem("keyDepartment"));
    let map = {
        deptCode: this.department.deptCode,
        queryRequest: {
          pageNum: 1,
          pageSize: 500,
          sortField: "",
          sortOrder: ""
        }
      };
      let res = await selectBDoctorinfo(map);
      this.list = res.data.obj.records;
  },
  computed: {
    departmentIcon() {
      if (this.department.iconurl) {
        return this.department.iconurl;
      }
      return require('@/assets/bg/bg_02.png');
    }
  },
  methods: {
    makebtn() {
      this.$router.push("/ChooseTime");
    },
    detailsbtn() {
      this.$router.push("/DepartmentDetails");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .brief {
    margin-top: 10px;
    padding: 24px 19px;
    background: #fff;
    > div {
      display: flex;
      flex-flow: row nowrap;
      > img {
        width: 108px;
        height: 80px;
        border-radius: 5px;
      }
      > div {
        margin-left: 23px;
        flex: 1;
        > p:nth-child(1) {
          margin: 10px 0px 16px;
          font-size: 17px;
          font-weight: bold;
        }
        > p:nth-child(2) {
          font-size: 14px;
          color: #707070;
        }
      }
    }
  }
  .doctorSel {
    display: flex;
    flex-flow: column nowrap;
    margin: 10px;
    > li {
      position: relative;
      margin-bottom: 10px;
      padding: 10px;
      background: #fff;
      display: flex;
      flex-flow: row;
      flex-flow: row nowrap;
      > img {
        width: 54px;
        height: 66px;
      }
      > div {
        margin: 0px 40px 0px 15px;
        color: #aeaeae;
        font-size: 12px;
        flex: 1;
        .doctor_name {
          position: relative;
          > span:nth-child(1) {
            font-size: 18px;
            font-weight: bold;
            color: #000;
            margin-right: 2px;
          }
          > span:nth-child(2) {
            position: relative;
            bottom: -2px;
          }
        }
        > p:nth-child(3) {
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          > img {
            width: 18px;
            position: absolute;
            bottom: 10px;
            right: 30px;
          }
        }
      }
      .yybtn_cl {
        position: absolute;
        top: 11px;
        right: 13px;
        background: #1c96cb;
        padding: 5px 12px;
        font-size: 13px;
        color: #fff;
        border-radius: 19px;
      }
    }
  }
  .depnone{
    margin: 10px;
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    padding: 60px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/website/DepartmentDoctor.vue